<script setup lang="ts">
const props = defineProps<{
  label?: string;
  color: string | undefined;
  disabled?: boolean;
}>();

const emit = defineEmits(["updateColor", "pickerStateChange"]);

const isOpen = ref(false);
const color = ref(props.color);

watch(isOpen, (value) => emit("pickerStateChange", value));

const set = () => {
  isOpen.value = false;
  emit("updateColor", color.value);
}
</script>

<template>
  <VLabel v-if="label" class="text-small">{{ label }}</VLabel>
  <div class="d-flex align-center">
    <VBtn
      :color="props.color || 'primary'"
      variant="flat"
      rounded="sm"
      class="flex-grow-1 border"
      :style="props.disabled ? { pointerEvents: 'none', opacity: '0.7' } : {}"
      @click="!props.disabled && (isOpen = true)"
    >
      {{ props.color ? "Change" : "Select" }}
    </VBtn>

    <VDialog v-model="isOpen" max-width="300" :scrim="false">
      <VCard>
        <div
          class="d-flex align-center justify-space-between bg-dialogHeaderColor"
        >
          <VCardTitle>Select Color</VCardTitle>
          <VBtn
            icon="mdi-close"
            size="large"
            variant="text"
            class="rounded-0"
            color=""
            @click="isOpen = false"
          />
        </div>

        <VColorPicker
          v-model="color"
          elevation="0"
          :modes="['hex']"
          mode="hex"
        />
        <VCardActions class="mt-2">
          <v-spacer></v-spacer>
          <VBtn variant="tonal" @click="set">
            Set
          </VBtn>
        </VCardActions>
      </VCard>
    </VDialog>

    <div>
      <VBtn
        size="small"
        variant="elevated"
        color="primary"
        icon="mdi-restore"
        class="ml-1"
        :disabled="props.disabled"
        @click="emit('updateColor', '')"
      />
      <VTooltip
        activator="parent"
        location="bottom"
        text="Clear Color"
      />
    </div>
  </div>
</template>
